import { collection, addDoc, serverTimestamp, doc, getDoc } from 'firebase/firestore';
import { db, auth } from '../firebase';

/**
 * Append-only audit for superuser actions (impersonation, tenant changes).
 */
export async function appendSuperuserAudit({ action, tenantId = null, details = null }) {
  const user = auth.currentUser;
  if (!user) return;
  let email = user.email || null;
  try {
    const profileSnap = await getDoc(doc(db, 'users', user.uid));
    if (profileSnap.exists()) email = profileSnap.data().email || email;
  } catch {
    /* ignore */
  }
  await addDoc(collection(db, 'superuserAuditLog'), {
    actorUid: user.uid,
    actorEmail: email,
    action,
    tenantId,
    details,
    createdAt: serverTimestamp(),
  });
}
